import getEditToken from "../../getters/editToken";

const plantUmlToken = getEditToken("plant-uml");

export default plantUmlToken;
